import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertIcon } from '@/ui/primitives/Icon';
import { useChatActions, useChatConfig, useChatState } from '@/ui/ChatProvider';
/** Connection-level errors. Per-message failures render inside the bubble. */
export function ErrorBanner() {
    const { copy } = useChatConfig();
    const { retryLast, init } = useChatActions();
    const error = useChatState((s) => s.error);
    const status = useChatState((s) => s.status);
    if (!error)
        return null;
    const isConnection = status === 'error';
    return (_jsxs("div", { className: "ac-error", role: "alert", children: [_jsx(AlertIcon, {}), _jsx("span", { children: error.message || copy.errorGeneric }), error.retryable && (_jsx("button", { type: "button", onClick: () => void (isConnection ? init() : retryLast()), children: copy.retry }))] }));
}
